import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { BrowserRouter as Router, Route, Routes, Link, Switch } from 'react-router-dom';

const List = () => {
    const { dir } = useParams();
    const [posts, setPosts] = useState([]);
    const API_BASE = process.env.REACT_APP_API_BASE;

    const formatTanggalID = (datetimeString) => {
        if (!datetimeString) return "";
        const date = new Date(datetimeString.replace(" ", "T"));
        return new Intl.DateTimeFormat("id-ID", {
            day: "numeric",
            month: "long",
            year: "numeric",
        }).format(date);
    };

  useEffect(() => {
    const fetchPosts = async () => {
    let postList = [];
     if(dir === "pengumuman") {
         const response = await fetch(
            `${API_BASE}/announcements.php?action=list`
        );
      
        const resJson = await response.json();
        postList = resJson.data || [];
       
     }else{
       const response = await fetch(
            `${API_BASE}/news.php?action=list`
        );
      
        const resJson = await response.json();
        postList = resJson.data || [];
     }
      console.log(postList);
      setPosts(postList);
    };

    fetchPosts();

    
  }, []);

    return (
        <div>
            <div class="ttm-page-title-row">
                <div class="ttm-page-title-row-inner  ttm-bgcolor-darkgrey">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-12" style={{textAlign:'left'}}>
                                <div class="page-title-heading">
                                    <h2 class="title">Semua {dir}</h2>
                                </div>
                                <div class="breadcrumb-wrapper">
                                    <span><a class="pathway" href="/">Home</a></span><span><a class="pathway" href="#"> {dir}</a></span>                                                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="site-main">
                <div class="ttm-row grid-section clearfix">
                    <div class="container">
                    
                        <div class="row">
                            {posts.map( item => (
                                <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                                    <div class="featured-imagebox featured-imagebox-post style1">
                                        <div class="ttm-post-thumbnail featured-thumbnail all-post">
                                            <img  class="img-fluid" src={item.image && item.image !== "" 
                                                ? item.image 
                                                : "/assets/post/default-image.png"} alt="default"
                                                style={{
                                                    width: "100%",
                                                    height: "250px",
                                                    objectFit: "cover",
                                                    objectPosition: "center",
                                                }}/>
                                        </div>
                                        <div class="featured-content featured-content-post ">
                                            <div class="post-meta">
                                                <span class="ttm-meta-line byline"><i class="ti ti-user"></i>{item.username}</span>
                                                <span class="ttm-meta-line cat-link"><i class="ti ti-calendar"></i>{formatTanggalID(item.created_at)}</span>
                                            </div>
                                            <div class="post-title featured-title">
                                                <h5><Link to={`/${dir === 'pengumuman' ? "pengumuman": "berita"}/${item.id}`}>{item.title}</Link></h5>
                                            </div>
                                        </div>
                                    </div>   
                                </div>                    
                            ))}
                                                
                        </div>
                
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;